import cards from './cards'
import form from './form'

export default {
  cards,
  form
}



// WEBPACK FOOTER //
// ./src/reducers/index.js